import type { DatasetsMutatorDeleteDatasetProps } from "./datasets-mutator-delete-dataset.type";

import { useDatasetDelete } from "@/entities/dataset";

import { useDatasetsMutatorHandleMutate } from "../datasets-mutator.hook";

export const useDatasetsMutatorDeleteDataset = ({
  mutatorItem,
  onDatasetDelete,
  invalidate,
}: DatasetsMutatorDeleteDatasetProps) => {
  const { datasetId } = mutatorItem;

  const { deleteDataset, status } = useDatasetDelete(datasetId, {
    invalidate,
    onSuccess: onDatasetDelete,
  });

  useDatasetsMutatorHandleMutate({
    mutatorItems: [mutatorItem],
    mutationStatus: status,
    onMutateReady: () => deleteDataset(),
  });

  return null;
};
